import { Text } from '@leroy-merlin-br/backyard-react'

import { ContentHeader } from '../../ContentHeader'
import { SecurityWarning } from '../../SecurityWarning'
import { PixVisualType } from './type'

const Pix = ({ orderId }: PixVisualType) => (
  <ContentHeader
    title={'Recebemos seu pedido!'}
    content={
      <>
        <Text>
          Número do pedido:{' '}
          <Text as="span" isBold>
            {orderId}
          </Text>
        </Text>
        <Text>
          Após a{' '}
          <Text as="span" isBold>
            aprovação do pagamento,
          </Text>{' '}
          vamos iniciar o processo de separação do seu pedido,{' '}
          <Text as="span" isBold>
            aguarde nosso e-mail de confirmação
          </Text>
        </Text>
        <SecurityWarning />
      </>
    }
  />
)

export default Pix
